"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = exports.isUndefined = exports.isSymbol = exports.isString = exports.isObject = exports.isNumber = exports.isNull = exports.isFunc = exports.isDate = exports.isBoolean = exports.isArray = exports.getType = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var getType = function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
};

exports.getType = getType;

var isFunc = function isFunc(value) {
  return typeof value === 'function';
};

exports.isFunc = isFunc;

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

exports.isBoolean = isBoolean;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return typeof value === 'number';
};

exports.isNumber = isNumber;

var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};

exports.isUndefined = isUndefined;

var isSymbol = function isSymbol(value) {
  return (0, _typeof2.default)(value) === 'symbol';
};

exports.isSymbol = isSymbol;

var isObject = function isObject(value) {
  return getType(value) === 'Object';
};

exports.isObject = isObject;

var isArray = function isArray(value) {
  return Array.isArray(value);
};

exports.isArray = isArray;

var isNull = function isNull(value) {
  return getType(value) === 'Null';
};

exports.isNull = isNull;

var isDate = function isDate(value) {
  return getType(value) === 'Date';
};

exports.isDate = isDate;

var toArray = function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }

  return value !== undefined ? [value] : [];
};

exports.toArray = toArray;